import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

/**
 * Internal dependencies.
 */
import "./_tile-content-with-image.scss"

// Atoms

const TileContentWithImage = ({ tiles, image, ...atomProps }) => {
  // set atom class
  const atomClassName = "tile-content-with-image"
  const atomClass =
    atomProps?.className !== undefined
      ? atomClassName + " " + atomProps.className
      : atomClassName

  const hasTiles = Array.isArray(tiles) && tiles.length > 0;

  return (
    <div comp={atomClassName} className={atomClass}>
      <div className="d-flex flex-column gap-3">
        <div className="d-flex gap-3">
          <div className="w-50">
            {hasTiles && tiles[0] && (
              <div className="tile h-100">
                <div className="d-flex flex-column gap-2">
                  <p className="title fs-40 mb-0">{tiles[0]?.title || ''}</p>
                  <p className="title fs-16 mb-0">{tiles[0]?.text || ''}</p>
                </div>
              </div>
            )}
          </div>
          <div className="w-50">
            {hasTiles && tiles.length > 1 && tiles[1] && (
              <div className="tile h-100">
                <div className="d-flex flex-column gap-2">
                  <p className="title fs-40 mb-0">{tiles[1]?.title || ''}</p>
                  <p className="title fs-16 mb-0">{tiles[1]?.text || ''}</p>
                </div>
              </div>
            )}
          </div>
        </div>
        {image && image.gatsbyImage && (
          <div className="image">
            <GatsbyImage
              className="w-100"
              image={image.gatsbyImage}
              objectFit="cover"
              alt={image.altText || "decorative image"}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default TileContentWithImage
